import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AclRoute, AgencyAclKeys, withPermission } from '@/lib/acl';

/**
 * Segment layout for `/agencies` — gates the WHOLE subtree (listing + detail +
 * any future child) behind one key. Children render in the Outlet; when the key
 * is absent the layout renders NotAuthorized instead, so no child mounts.
 * Add a child route → it's gated automatically. (ENT-89 T15.)
 */
export const Route = createFileRoute('/agencies')({
  component: withPermission(Outlet, {
    key: AgencyAclKeys.listingRead,
    route: AclRoute.AGENCY,
    resourceLabel: 'Agencies',
  }),
});
